module.exports = __webpack_public_path__ + "app/web/assets/images/zoho_faq2.png";